<template>
  <el-dialog
    title="流水清单"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
    customClass="customWidth"
  >


        <el-form
                :inline="true"
                :model="searchForm"
                ref="searchForm"
                size="small"
                style="margin-bottom: -18px;"
        >
          <el-form-item
          >
            <el-input
                    v-model="searchForm.mer_order_id"
                    placeholder="订单号"
                    style="width: 100px;"
            />
          </el-form-item>

          <el-form-item>
            <el-date-picker
                    v-model="dateRange"
                    :picker-options="pickerOptions"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"    width="150">

            </el-date-picker>

          </el-form-item>

          <el-form-item>
            <el-button
                    type="primary"
                    @click="handleSearchFormSubmit"
            >
              <d2-icon name="search" /> 查询
            </el-button>
            <el-button @click="handleSearchFormReset">
              <d2-icon name="refresh" /> 重置
            </el-button>
            <el-button @click="handleExportFormSubmit">
              导出
            </el-button>
          </el-form-item>
        </el-form>

    <div class="header2" flex="main:justify cross:center">
      订单总数 {{order_num}}笔； 订单总金额 {{order_amount}}元； 退款总金额 {{refund_amount}}元； 顾客实付 {{payment_amount}}元； 优惠 {{discount_amount}}元
    </div>
      <el-table
              :data="tableData"
              v-loading="loading"
              size="small"
              stripe
              highlight-current-row
              style="width: 100%;"
              @selection-change="handleSelectionChange"
              @sort-change="handleSortChange"
      >

        <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
        </el-table-column>



        <el-table-column
                label="订单号"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.mer_order_id}}
          </template>
        </el-table-column>
        <el-table-column
                label="门店"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.affiliated_store}}
          </template>
        </el-table-column>
        <el-table-column
                label="订单金额"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.order_amt_total}}
          </template>
        </el-table-column>
        <el-table-column
                label="创建时间"
                prop="notice_time2"
                sortable="custom"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.order_time2}}
          </template>
        </el-table-column>

        <el-table-column
                label="状态"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.return_code=='0000'">
              <div v-if="scope.row.refund_no!=''">
                全额退款成功
              </div>
              <div v-else> 成功</div>
            </div>
            <div v-else> 未支付</div>
          </template>
        </el-table-column>

        <el-table-column
                label="支付方式"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.refund_no!=''">
              退款
            </div>
            <div v-else>
              <div v-if="scope.row.pay_type=='微信刷脸'">
                微信
              </div>
              <div v-else-if="scope.row.pay_type=='支付宝刷脸'">
                支付宝
              </div>
              <div v-else-if="scope.row.pay_type=='银行卡'">
                银行卡
              </div>
              <div v-else-if="scope.row.pay_type=='会员卡'">
                会员卡
              </div>
            </div>


          </template>
        </el-table-column>
        <el-table-column
                label="支付通道"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
         官方
          </template>
        </el-table-column>
        <el-table-column
                label="顾客实付"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.order_amt}}
          </template>
        </el-table-column>
        <el-table-column
                label="优惠"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.reduce_cost}}
          </template>
        </el-table-column>

      </el-table>
    <div style="text-align: center;margin-top: 30px;">
        <el-pagination
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                :page-sizes="[1,10,50,100, 200, 300, 400]"
                layout="total, sizes, prev, pager, next, jumper"
                style="margin: -10px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
        >
        </el-pagination>

    </div>
  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
export default {
  name: "agentEditForm",
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        searchForm: {
            mer_order_id:""
      },
        order_amount:'0',
        order_num:'0',
        refund_amount:'0',
        payment_amount:'0',
        discount_amount:'0',
        loading: false,
        tableData: [],
        multipleSelection: [],
        dateRange: [],
        pickerOptions:{},
        page: {
            current: 1,
            size: 10,
            total: 0
        },
        sort: {
            prop: "",
            order: ""
        }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.searchForm.resetFields();
      this.getTableData();
        this.getTableDataMx();
    },
      dateConversion(value) {
          if (value != null && value != "") {
              var d = new Date(value);
              //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
              var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              console.info("===========date=========" + date);
              return date;
          }else{
              return "";
          }
      },
      getTableDataMx() {
          var formData4 = new FormData() // 声明一个FormData对象
          formData4.append("agentid",this.agent.agentid);
          formData4.append("start_time", this.dateConversion(this.dateRange[0]));
          formData4.append("end_time", this.dateConversion(this.dateRange[1]));
          formData4.append("serial_no",this.agent.serial_number);
          formData4.append("mer_order_id",this.searchForm.mer_order_id);
          agentService.getStatisticsJymx(formData4).then(data => {
              if(data!=null && data!=""){
                  this.order_amount=data.order_amount;
                  this.order_num=data.order_num;
                  this.refund_amount=data.refund_amount;
                  this.payment_amount=data.payment_amount;
                  this.discount_amount=data.discount_amount;


              }
          });

          //

      },
      getTableData() {
          let query = {
              pageIndex: this.page.current,
              pageSize: this.page.size,
              sortBy: this.sort.prop,
              agentid: this.agent.agentid,
              start_time:this.dateConversion(this.dateRange[0]),
              end_time:this.dateConversion(this.dateRange[1]),
              serial_no: this.agent.serial_number,
              descending: this.sort.order === "descending",
              filter: this.searchForm
          };
          agentService.getMoblieOrderSbPagedList(query).then(data => {
              this.tableData = data.rows;
              this.page.total = data.totalCount;
          });
      },
      handleSearchFormSubmit() {
          this.getTableData();
          this.getTableDataMx();
      },
      handleSearchFormReset() {
          this.$refs.searchForm.resetFields();
      },
      handleExportFormSubmit() {
          window.location.href=encodeURI(process.env.VUE_APP_API+"/moblieapp/mobileOrderSbExcel?agentid="+this.agent.agentid+"&start_time="+this.dateConversion(this.dateRange[0])+"&end_time="+this.dateConversion(this.dateRange[1])+"&serial_no="+ this.agent.serial_number+"&mer_order_id="+this.searchForm.mer_order_id);
      },
      handleSelectionChange(val) {
          this.multipleSelection = val;
      },
      handleSortChange(val) {
          this.sort.prop = val.prop;
          this.sort.order = val.order;
          this.getTableData();
      },
      handleSizeChange(val) {
          this.page.size = val;
          this.getTableData();
      },
      handleCurrentChange(val) {
          this.page.current = val;
          this.getTableData();
      },
    close() {
      this.$refs["searchForm"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
<style>
  .customWidth{
    width:90%;
  }
  .header2 {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
